import {getFilterStrFromObj} from "../../../../../utils/filter";
import _ from "lodash";
import {getTreeFilterStrFromObj} from "../../../../../components/tree-filter/utils";

export const QUERY_FORM_FILTER_MODE_PLAIN = 'QUERY_FORM_FILTER_MODE_PLAIN';
export const QUERY_FORM_FILTER_MODE_TREE = 'QUERY_FORM_FILTER_MODE_TREE';

export const getStrAccordingToFilterMode = (filterMode, obj, treeObj, columns) => filterMode === QUERY_FORM_FILTER_MODE_PLAIN
    ?
    getFilterStrFromObj(
        obj,
        columns !== null && Array.isArray(columns)
            ? _.flatten(Object.keys(columns)
                .map(key => columns[key]))
            : null)
    :
    getTreeFilterStrFromObj(
        treeObj,
        columns !== null && Array.isArray(columns)
            ? _.flatten(Object.keys(columns)
                .map(key => columns[key])).map(({name}) => name)
            : null
    )